// import { ErrorHandler, Injectable } from "@angular/core";

import { ErrorHandler, Injectable } from "@angular/core";
import { Router } from "@angular/router";

@Injectable()
/**
 * Global Angular error handler; logs uncaught errors to the console and
 * rethrows them (currently acts as a pass-through placeholder).
 */
export class ErrorGenericHandler implements ErrorHandler {
  constructor(private router: Router) {}

  /**
   * Handles an uncaught application error by logging and rethrowing it.
   * @param error The uncaught error.
   */
  handleError(error: any): void {
    console.log(error);

    throw(error);
  }
}
